const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronUpFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3.19995C8.21218 3.19995 8.41566 3.28424 8.56569 3.43427L10.9657 5.83427C11.2781 6.14669 11.2781 6.65322 10.9657 6.96564C10.6533 7.27806 9.6 7.19995 9.6 7.19995H8H6.4C6 7.19995 5.34674 7.27806 5.03432 6.96564C4.7219 6.65322 4.7219 6.14668 5.03432 5.83427L7.43432 3.43427C7.58435 3.28424 7.78783 3.19995 8 3.19995Z",
    fill: "#718096",
    style: {
      fill: "#718096",
      fill: "color(display-p3 0.4431 0.5020 0.5882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M6.16569 8.79994C6.16569 8.79994 5.34674 8.72183 5.03432 9.03425C4.7219 9.34667 4.7219 9.8532 5.03432 10.1656L7.43432 12.5656C7.74674 12.878 8.25327 12.878 8.56569 12.5656L10.9657 10.1656C11.2781 9.8532 11.2781 9.34667 10.9657 9.03425C10.6533 8.72183 10 8.79994 10 8.79994H8H6.16569Z",
    fill: "#718096",
    style: {
      fill: "#718096",
      fill: "color(display-p3 0.4431 0.5020 0.5882)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpFilled);
export default __webpack_public_path__ + "static/media/chevron-up-filled.1419145d979d04bc95e0a5c5eaca7e40.svg";
export { ForwardRef as ReactComponent };